  (() => {
    if (window.BeeProductStoryShareFinalReady) return;
    window.BeeProductStoryShareFinalReady = true;

    let alignmentFrame;

    function alignShareButtons() {
      document.querySelectorAll('[data-product-story-share]').forEach((root) => {
        const wrapper = root.closest('.bee-product__media-wrapper');
        if (!wrapper) return;

        const iconButtons = Array.from(wrapper.querySelectorAll('.bee-pr__icon-btn')).filter((button) => {
          if (root.contains(button)) return false;

          const rect = button.getBoundingClientRect();
          const style = window.getComputedStyle(button);
          return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
        });

        if (!iconButtons.length) {
          root.removeAttribute('data-icon-aligned');
          return;
        }

        const reference = iconButtons.sort((first, second) => {
          const firstRect = first.getBoundingClientRect();
          const secondRect = second.getBoundingClientRect();
          return secondRect.right - firstRect.right || secondRect.bottom - firstRect.bottom;
        })[0];
        const wrapperRect = wrapper.getBoundingClientRect();
        const referenceRect = reference.getBoundingClientRect();

        root.style.setProperty('--bee-story-share-top', `${referenceRect.top - wrapperRect.top}px`);
        root.style.setProperty('--bee-story-share-width', `${referenceRect.width}px`);
        root.style.setProperty('--bee-story-share-height', `${referenceRect.height}px`);
        root.setAttribute('data-icon-aligned', 'true');
      });
    }

    function scheduleShareAlignment() {
      window.cancelAnimationFrame(alignmentFrame);
      alignmentFrame = window.requestAnimationFrame(alignShareButtons);
    }

    function loadImage(url) {
      return new Promise((resolve, reject) => {
        if (!url) {
          reject(new Error('Image URL is empty'));
          return;
        }

        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => resolve(image);
        image.onerror = reject;
        image.src = new URL(url, window.location.origin).href;
      });
    }

    function roundedRect(context, x, y, width, height, radius) {
      const r = Math.min(radius, width / 2, height / 2);
      context.beginPath();
      context.moveTo(x + r, y);
      context.arcTo(x + width, y, x + width, y + height, r);
      context.arcTo(x + width, y + height, x, y + height, r);
      context.arcTo(x, y + height, x, y, r);
      context.arcTo(x, y, x + width, y, r);
      context.closePath();
    }

    function drawContain(context, image, x, y, width, height) {
      const scale = Math.min(width / image.width, height / image.height);
      const renderedWidth = image.width * scale;
      const renderedHeight = image.height * scale;
      context.drawImage(image, x + (width - renderedWidth) / 2, y + (height - renderedHeight) / 2, renderedWidth, renderedHeight);
    }

    function drawBlob(context, x, y, radius, color) {
      context.save();
      context.fillStyle = color;
      context.beginPath();
      context.arc(x, y, radius, 0, Math.PI * 2);
      context.fill();
      context.restore();
    }

    function drawThinLogo(context, x, y, font) {
      context.save();
      context.textAlign = 'right';
      context.textBaseline = 'middle';
      context.font = `800 31px ${font}`;
      context.fillStyle = '#6f1f30';
      context.fillText('royal.az', x, y);

      context.fillStyle = '#ff7a1a';
      context.beginPath();
      context.arc(x - 145, y, 7, 0, Math.PI * 2);
      context.fill();
      context.restore();
    }

    function textLines(context, text, maxWidth, maxLines) {
      const words = String(text || '').split(/\s+/).filter(Boolean);
      const lines = [];
      let line = '';
      let truncated = false;

      words.forEach((word) => {
        const test = line ? `${line} ${word}` : word;
        if (context.measureText(test).width <= maxWidth || !line) {
          line = test;
        } else if (lines.length < maxLines - 1) {
          lines.push(line);
          line = word;
        } else {
          truncated = true;
        }
      });

      if (line && lines.length < maxLines) lines.push(line);
      if (truncated && lines.length) lines[lines.length - 1] = `${lines[lines.length - 1]}…`;
      return lines;
    }

    function productData(root) {
      const relativeUrl = root.dataset.productUrl || '';
      return {
        mode: root.dataset.storyMode || 'product',
        title: (root.dataset.productTitle || '').trim(),
        description: (root.dataset.productDescription || '').trim(),
        price: (root.dataset.productPrice || '').trim(),
        priceCents: Number(root.dataset.productPriceCents || 0),
        comparePrice: (root.dataset.productComparePrice || '').trim(),
        image: (root.dataset.productImage || '').trim(),
        url: relativeUrl ? new URL(relativeUrl, window.location.origin).href : window.location.href
      };
    }

    function storyText(mode) {
      if (mode === 'audio') return { badge: 'Audio nümunəsi', cta: 'SƏSİNİ DİNLƏ' };
      if (mode === 'video') return { badge: 'Video təqdimatı', cta: 'VİDEOYA BAX' };
      return { badge: 'Məhsulu kəşf et', cta: 'ƏTRAFLI BAX' };
    }

    function monthlyCreditText(priceCents) {
      const price = Number(priceCents || 0) / 100;
      if (!price) return '';

      const unofficialRate = 31.6;
      const months = 12;
      const total = price + price * unofficialRate / 100;
      const monthly = total / months;
      const roundedMonthly = Math.ceil(monthly);

      return `${roundedMonthly} ₼ / ${months} ay`;
    }

    function drawCreditPill(context, x, y, text, font) {
      if (!text) return;

      context.save();

      const width = 356;
      const height = 82;
      const centerX = x + width / 2;

      context.shadowColor = 'rgba(23, 163, 74, 0.22)';
      context.shadowBlur = 20;
      context.shadowOffsetY = 10;

      const gradient = context.createLinearGradient(x, y, x + width, y + height);
      gradient.addColorStop(0, '#4ade80');
      gradient.addColorStop(0.58, '#22c55e');
      gradient.addColorStop(1, '#17a34a');
      roundedRect(context, x, y, width, height, 41);
      context.fillStyle = gradient;
      context.fill();

      context.shadowColor = 'transparent';
      context.shadowBlur = 0;
      context.shadowOffsetY = 0;

      context.fillStyle = 'rgba(255, 255, 255, 0.16)';
      context.beginPath();
      context.arc(x + 36, y + 15, 52, 0, Math.PI * 2);
      context.fill();

      context.fillStyle = 'rgba(255, 255, 255, 0.72)';
      context.font = `800 16px ${font}`;
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.fillText('Kreditlə aylıq', centerX, y + 24);

      context.fillStyle = '#ffffff';
      context.font = `900 34px ${font}`;
      context.fillText(text, centerX, y + 54);

      context.textAlign = 'left';
      context.textBaseline = 'alphabetic';

      context.restore();
    }

    function drawBadge(context, x, y, label, mode, font) {
      context.save();

      context.font = `800 24px ${font}`;
      const width = context.measureText(label).width + 78;

      roundedRect(context, x, y, width, 54, 27);
      context.fillStyle = mode === 'audio' ? 'rgba(255, 102, 0, .10)' : 'rgba(111, 31, 48, .075)';
      context.fill();
      context.fillStyle = mode === 'audio' ? '#ff6600' : '#6f1f30';
      context.beginPath();
      context.arc(x + 29, y + 27, 15, 0, Math.PI * 2);
      context.fill();
      context.fillStyle = '#fff';
      context.beginPath();
      context.moveTo(x + 25, y + 19);
      context.lineTo(x + 25, y + 35);
      context.lineTo(x + 38, y + 27);
      context.closePath();
      context.fill();
      context.fillStyle = mode === 'audio' ? '#8a4a12' : '#5f2733';
      context.textBaseline = 'middle';
      context.fillText(label, x + 56, y + 27);
      context.restore();
    }

    function drawSaleBadge(context, x, y, font) {
      const label = 'Endirimdə';

      context.save();

      context.font = `900 23px ${font}`;
      const width = context.measureText(label).width + 66;
      const height = 52;

      context.shadowColor = 'rgba(255, 102, 0, 0.18)';
      context.shadowBlur = 16;
      context.shadowOffsetY = 8;

      const gradient = context.createLinearGradient(x, y, x + width, y + height);
      gradient.addColorStop(0, '#ffad63');
      gradient.addColorStop(1, '#ff6600');

      roundedRect(context, x, y, width, height, 27);
      context.fillStyle = gradient;
      context.fill();

      context.shadowColor = 'transparent';
      context.shadowBlur = 0;
      context.shadowOffsetY = 0;

      context.fillStyle = 'rgba(255, 255, 255, 0.20)';
      context.beginPath();
      context.arc(x + 26, y + 26, 33, 0, Math.PI * 2);
      context.fill();

      context.fillStyle = '#ffffff';
      context.font = `900 18px ${font}`;
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.fillText('%', x + 27, y + 27);

      context.font = `900 23px ${font}`;
      context.textAlign = 'left';
      context.fillText(label, x + 50, y + 27);

      context.restore();
    }

    async function createStoryFile(product) {
      const canvas = document.createElement('canvas');
      canvas.width = 1080;
      canvas.height = 1920;
      const context = canvas.getContext('2d');
      const font = 'Quicksand, -apple-system, BlinkMacSystemFont, sans-serif';
      const copy = storyText(product.mode);

      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, 1080, 1920);

      drawBlob(context, -115, 130, 365, '#fff4ec');
      drawBlob(context, 1108, 1565, 410, '#fff1e8');
      drawBlob(context, 540, 605, 430, 'rgba(74, 222, 128, 0.055)');
      drawBlob(context, 930, 360, 96, 'rgba(255, 102, 0, 0.055)');

      drawBadge(context, 58, 64, copy.badge, product.mode, font);
      if (product.comparePrice) {
        drawSaleBadge(context, 58, 130, font);
      }

      drawThinLogo(context, 1018, 92, font);

      context.save();
      context.fillStyle = 'rgba(255, 255, 255, 0.46)';
      roundedRect(context, 72, 190, 936, 850, 56);
      context.fill();
      context.restore();

      if (product.image) {
        try {
          const image = await loadImage(product.image);
          drawContain(context, image, 92, 220, 896, 790);
        } catch (error) {}
      }

      context.save();
      context.shadowColor = 'rgba(217, 96, 13, 0.035)';
      context.shadowBlur = 26;
      context.shadowOffsetY = 14;
      roundedRect(context, 48, 1088, 984, 626, 48);
      context.fillStyle = 'rgba(255, 251, 247, 0.92)';
      context.fill();
      context.restore();

      context.fillStyle = '#201c1a';
      context.font = `800 54px ${font}`;
      const titleLines = textLines(context, product.title || 'Musiqi aləti', 880, 2);
      titleLines.forEach((line, index) => context.fillText(line, 78, 1194 + index * 62));
      const titleBottom = 1194 + (titleLines.length - 1) * 62;
      const priceY = titleBottom + 90;

      context.fillStyle = '#d9600d';
      context.font = `900 49px ${font}`;
      context.fillText(product.price || '', 64, priceY);
      const priceWidth = context.measureText(product.price || '').width;

      if (product.comparePrice) {
        const compareX = Math.min(64 + priceWidth + 28, 690);
        const compareY = priceY - 2;
        context.fillStyle = '#a89d92';
        context.font = `600 28px ${font}`;
        context.fillText(product.comparePrice, compareX, compareY);
        const compareWidth = context.measureText(product.comparePrice).width;
        context.beginPath();
        context.moveTo(compareX - 2, compareY - 10);
        context.lineTo(compareX + compareWidth + 2, compareY - 10);
        context.strokeStyle = '#a89d92';
        context.lineWidth = 3;
        context.stroke();
      }

      drawCreditPill(context, 650, priceY - 61, monthlyCreditText(product.priceCents), font);

      context.fillStyle = '#81756c';
      context.font = `600 28px ${font}`;
      const descriptionLines = textLines(context, product.description || 'Məhsul haqqında ətraflı məlumatı kəşf et.', 952, 2);
      const descriptionY = priceY + 90;
      descriptionLines.forEach((line, index) => context.fillText(line, 78, descriptionY + index * 40));

      const actionY = 1580;
      roundedRect(context, 78, actionY, 420, 98, 49);
      const gradient = context.createLinearGradient(78, actionY, 498, actionY + 98);
      gradient.addColorStop(0, '#e9872d');
      gradient.addColorStop(1, '#d9600d');
      context.fillStyle = gradient;
      context.fill();
      context.fillStyle = 'rgba(255, 255, 255, 0.18)';
      context.beginPath();
      context.arc(128, actionY + 49, 31, 0, Math.PI * 2);
      context.fill();
      context.fillStyle = '#fff';
      context.beginPath();
      context.moveTo(122, actionY + 35);
      context.lineTo(122, actionY + 63);
      context.lineTo(144, actionY + 49);
      context.closePath();
      context.fill();
      context.font = `900 29px ${font}`;
      context.fillText(copy.cta, 174, actionY + 60);

      context.fillStyle = '#6f1f30';
      context.font = `800 24px ${font}`;
      context.fillText('royal.az', 78, 1818);

      context.fillStyle = '#a3968d';
      context.font = `600 22px ${font}`;
      context.fillText(new URL(product.url).hostname, 78, 1850);
      context.textAlign = 'right';
      context.fillText('Royal · Musiqi alətləri mağazası', 1002, 1850);

      const blob = await new Promise((resolve, reject) => {
        canvas.toBlob((result) => result ? resolve(result) : reject(new Error('Story image failed')), 'image/png', 0.95);
      });
      return new File([blob], 'royal-product-story.png', { type: 'image/png' });
    }

    function showStatus(root, message) {
      const status = root.querySelector('[data-product-story-status]');
      if (!status) return;

      status.textContent = message;
      window.setTimeout(() => {
        status.textContent = '';
      }, 2200);
    }

    function closeAllMenus() {
      document.querySelectorAll('[data-product-story-menu]:not([hidden])').forEach((menu) => {
        menu.hidden = true;
        const root = menu.closest('[data-product-story-share]');
        const button = root && root.querySelector('[data-product-story-button]');
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    }

    async function copyToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return;
      }

      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      textarea.remove();
    }

    async function handleStoryShareClick(event) {
      const target = event.target instanceof Element ? event.target : event.target && event.target.parentElement;
      if (!target) return;

      const trigger = target.closest('[data-product-story-button]');
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();

        const root = trigger.closest('[data-product-story-share]');
        if (!root) return;

        const menu = root.querySelector('[data-product-story-menu]');
        if (!menu) return;

        const willOpen = menu.hidden;
        closeAllMenus();
        menu.hidden = !willOpen;
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        return;
      }

      const option = target.closest('[data-product-share-kind]');
      if (option) {
        event.preventDefault();
        event.stopPropagation();

        const root = option.closest('[data-product-story-share]');
        if (!root) return;

        const menu = root.querySelector('[data-product-story-menu]');
        if (menu) menu.hidden = true;

        const triggerButton = root.querySelector('[data-product-story-button]');
        if (triggerButton) triggerButton.setAttribute('aria-expanded', 'false');

        const product = productData(root);
        const kind = option.dataset.productShareKind;
        const text = `${product.title || 'Bu məhsul'} — Royal.az`;

        if (kind === 'instagram') {
          showStatus(root, 'Story hazırlanır…');
          try {
            const file = await createStoryFile(product);
            if (navigator.share && (!navigator.canShare || navigator.canShare({ files: [file] }))) {
              await navigator.share({ files: [file], title: product.title, text });
            } else {
              const download = document.createElement('a');
              download.href = URL.createObjectURL(file);
              download.download = file.name;
              document.body.appendChild(download);
              download.click();
              download.remove();
              window.setTimeout(() => URL.revokeObjectURL(download.href), 1000);
              showStatus(root, 'Story şəkli endirildi');
            }
          } catch (error) {
            showStatus(root, 'Story hazırlamaq olmadı');
          }
        } else if (kind === 'native') {
          if (navigator.share) {
            try {
              await navigator.share({ title: product.title, text, url: product.url });
            } catch (error) {}
          } else {
            try {
              await copyToClipboard(product.url);
              showStatus(root, 'Link kopyalandı');
            } catch (error) {
              window.open(product.url, '_blank', 'noopener');
            }
          }
        } else if (kind === 'whatsapp') {
          window.open(`https://wa.me/?text=${encodeURIComponent(`${text} ${product.url}`)}`, '_blank', 'noopener');
        } else if (kind === 'telegram') {
          window.open(`https://t.me/share/url?url=${encodeURIComponent(product.url)}&text=${encodeURIComponent(text)}`, '_blank', 'noopener');
        } else if (kind === 'copy') {
          try {
            await copyToClipboard(product.url);
            showStatus(root, 'Link kopyalandı');
          } catch (error) {
            showStatus(root, 'Linki kopyalamaq olmadı');
          }
        }
        return;
      }

      closeAllMenus();
    }

    document.addEventListener('click', handleStoryShareClick, true);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAllMenus();
    });
    document.addEventListener('shopify:section:load', scheduleShareAlignment);
    window.addEventListener('resize', scheduleShareAlignment, { passive: true });
    window.addEventListener('load', scheduleShareAlignment, { once: true });
    scheduleShareAlignment();
  })();
